// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: true,
    apiUrl: "https://ale-shansab.com:8000/api/v1", 
    imageUrl: "https://ale-shansab.com:8000/upload_folder/",
    languages: {
        "FA_IR": 2,
        "EN_US": 1
    },
    domainName: "https://ale-shansab.com"
};

export const getApiUrl = () => environment.apiUrl;
export const getImgeUrl = () => environment.imageUrl
export const getLanguages = () => environment.languages
export const getDomainName = () => environment.domainName
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
